(() => {
  const sampled = new Map();
  function tone(source) {
    if (sampled.has(source)) return sampled.get(source);
    const promise = new Promise(resolve => {
      const image = new Image();
      image.crossOrigin = 'anonymous';
      image.onload = () => {
        try {
          const canvas = document.createElement('canvas');
          canvas.width = canvas.height = 80;
          const context = canvas.getContext('2d', {willReadFrequently: true});
          context.drawImage(image, 0, 0, 80, 80);
          const pixels = context.getImageData(0, 0, 80, 80).data;
          const groups = new Map();
          for (let y = 38; y < 66; y++) for (let x = 25; x < 55; x++) {
            if (x > 33 && x < 47 && y < 53) continue;
            const i = (y * 80 + x) * 4;
            if (pixels[i + 3] < 200) continue;
            const rgb = [pixels[i], pixels[i + 1], pixels[i + 2]];
            const key = rgb.map(v => Math.floor(v / 24)).join(',');
            const group = groups.get(key) || {n: 0, rgb: [0, 0, 0]};
            group.n++;
            rgb.forEach((v, c) => group.rgb[c] += v);
            groups.set(key, group);
          }
          const winner = [...groups.values()].sort((a, b) => b.n - a.n)[0];
          resolve(winner ? `rgb(${winner.rgb.map(v => Math.round(v / winner.n)).join(',')})` : null);
        } catch (_) { resolve(null); }
      };
      image.onerror = () => resolve(null);
      image.src = source;
    });
    sampled.set(source, promise);
    return promise;
  }
  function refresh(picker) {
    picker.querySelectorAll('.product-variant').forEach(group => {
      const output = group.querySelector('.s2-selected-color');
      const selected = group.querySelector('input:checked');
      const display = selected && (selected.dataset.displayLabel || selected.value);
      if (output && selected && output.textContent !== display) output.textContent = display;
    });
    const page = picker.closest('.s2-product-simple');
    const combinations = picker.querySelector('[data-s2-variant-combinations]');
    if (combinations) {
      const data = JSON.parse(combinations.textContent);
      if (data.complete) {
        const groups = [...picker.querySelectorAll('[data-js-product-variant-container]')];
        const selected = groups.map(group => group.querySelector('input:checked')?.value || group.value);
        groups.forEach((group, position) => group.querySelectorAll('input').forEach(input => {
          const options = selected.map((value, i) => i === position ? input.value : value);
          const available = data.variants.some(variant => variant.available && variant.options.every((value, i) => !options[i] || value === options[i]));
          input.dataset.available = String(available);
          input.classList.toggle('disabled', !available);
          input.closest('.product-variant__item').classList.toggle('disabled', !available);
        }));
      }
    }
    picker.querySelectorAll('.s2-color-option input').forEach(input => {
      const label = input.nextElementSibling;
      if (label) label.title = input.dataset.available === 'false' ? `${input.value} – ${label.dataset.s2SoldOutLabel}` : input.value;
    });
    const primary = page.querySelector('[data-js-product-add-to-cart]');
    const buyNow = page.querySelector('[data-s2-buy-now]');
    const unavailable = primary && (primary.disabled || primary.classList.contains('disabled'));
    if (buyNow && primary) buyNow.disabled = unavailable;
    const notice = page.querySelector('.s2-stock-notice');
    if (notice) {
      notice.hidden = !unavailable;
      page.classList.toggle('s2-combination-unavailable', unavailable);
      const gallery = page.querySelector('.product-gallery');
      if (gallery) gallery.dataset.s2StockLabel = notice.textContent;
    }
    picker.querySelectorAll('[data-s2-swatch-source]').forEach(swatch => {
      if (swatch.dataset.sampled) return;
      swatch.dataset.sampled = 'true';
      tone(swatch.dataset.s2SwatchSource).then(color => {
        if (color) swatch.style.backgroundColor = color;
      });
    });
  }
  function initThumbnails() {
    document.querySelectorAll('.s2-product-simple .product-gallery__thumbnails').forEach(gallery => {
      if (gallery.dataset.s2ThumbReady) return;
      const holder = gallery.querySelector('.product-gallery__thumbnails-holder');
      const previous = gallery.querySelector('.s2-thumb-prev');
      const next = gallery.querySelector('.s2-thumb-next');
      if (!holder || !previous || !next) return;
      gallery.dataset.s2ThumbReady = 'true';
      const update = () => {
        previous.hidden = holder.scrollLeft <= 2;
        next.hidden = holder.scrollWidth - holder.clientWidth - holder.scrollLeft <= 2;
      };
      const move = direction => holder.scrollBy({left: direction * Math.max(70, holder.clientWidth * .7), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      holder.addEventListener('scroll', update, {passive:true});
      const observer = new ResizeObserver(() => {
        if (!gallery.isConnected) return observer.disconnect();
        update();
      });
      observer.observe(holder);
      update();
    });
  }
  function init() {
    initThumbnails();
    document.querySelectorAll('.s2-product-simple product-variants').forEach(picker => {
      if (picker.dataset.simpleReady) return;
      picker.dataset.simpleReady = 'true';
      picker.addEventListener('change', () => refresh(picker));
      picker.addEventListener('VARIANT_CHANGE', () => refresh(picker));
      refresh(picker);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();


